import Form from 'epn-ui/umd/dist/components/Form';
import InputText from 'epn-ui/umd/dist/components/InputText';

// Helpers
import useI18n from '@i18n';
import { ISupportCreateMessageFormProps } from '../interface';

// Conponents
import CreateMessageActions from '../TemplateActions';

const SupportToolsForm: React.FC<ISupportCreateMessageFormProps> = ({
    question,
    subject,
    loading,
    onClose,
    onSubmit,
}) => {
    const { t } = useI18n('Support');
    const { t: tCommon } = useI18n('Common');

    return (
        <Form
            name="tools"
            onFinish={values => {
                const files = [];

                if (
                    values.files &&
                    Array.isArray(values.files.fileList) &&
                    values.files.fileList.length > 0
                ) {
                    values.files.fileList.forEach(item => {
                        files.push({
                            name: item.name,
                            size: item.size,
                            link: item.response,
                        });
                    });
                }

                onSubmit({
                    subject: values.subject,
                    message: values.message,
                    files,
                });
            }}
            initialValues={{
                message: question,
                subject,
            }}
        >
            <Form.Item
                name="subject"
                rules={[{ required: true, message: tCommon('Required field') }]}
                className="hidden"
            >
                <InputText />
            </Form.Item>

            <Form.Item
                name="message"
                rules={[{ required: true, whitespace: true, message: tCommon('Required field') }]}
            >
                <InputText.TextArea
                    placeholder={t('Additional comment')}
                    autoSize={{
                        minRows: 4,
                    }}
                />
            </Form.Item>

            <CreateMessageActions loading={loading} onClose={onClose} />
        </Form>
    );
};

export default SupportToolsForm;
